module.exports = __webpack_public_path__ + "img/Speaker=Carrie Lim.a3661bec.png";